import { LabelWithValue } from '@/components/common/LabelWithValue';
import { formatDisplayDate, formatDisplayDateTime } from '@/utils/date';
import { formatNumber } from '@/utils/number';
import type { PcmpProjectDetail } from '../types/pcmpProject.types';
import { PcmpProjectVisibility } from './PcmpProjectVisibility';

interface PcmpProjectInfoCardProps {
  project: PcmpProjectDetail;
}

export function PcmpProjectInfoCard({ project }: PcmpProjectInfoCardProps) {
  return (
    <section className="flex flex-col gap-4 rounded-xl border bg-card p-5 shadow-sm">
      <h2 className="text-lg font-semibold">Project</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <LabelWithValue label="Code">
          {project.code ? <span className="font-mono">{project.code}</span> : null}
        </LabelWithValue>
        <LabelWithValue label="Company">{project.companyName}</LabelWithValue>
        <LabelWithValue label="Book Edition">{project.bookEditionName}</LabelWithValue>
        <LabelWithValue label="SL No">{project.slNo}</LabelWithValue>
        <LabelWithValue label="Active From">
          {project.activeFrom ? formatDisplayDate(project.activeFrom) : null}
        </LabelWithValue>
        <LabelWithValue label="Active To">
          {project.activeTo ? formatDisplayDate(project.activeTo) : null}
        </LabelWithValue>
        <LabelWithValue label="Visible On">
          <PcmpProjectVisibility
            isWebVisible={project.isWebVisible}
            isMobileVisible={project.isMobileVisible}
          />
        </LabelWithValue>
        <LabelWithValue label="Submissions">{formatNumber(project.submissionCount)}</LabelWithValue>
        <LabelWithValue label="Created">{formatDisplayDateTime(project.createdAt)}</LabelWithValue>
        <LabelWithValue label="Last Updated">
          {formatDisplayDateTime(project.updatedAt)}
        </LabelWithValue>
      </div>
      {project.description ? (
        <LabelWithValue label="Description">
          <span className="whitespace-pre-line font-normal">{project.description}</span>
        </LabelWithValue>
      ) : null}
    </section>
  );
}
